// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input-group {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  width: 100%;
}

.custom-input-label {
  font-family: var(--font-family-regular);
  font-size: var(--font-size-base);
  font-weight: 400;
  color: #374151;
  line-height: 1.2;
}

.required-asterisk {
  color: #dc2626;
  margin-left: 2px;
}

.custom-input-container {
  position: relative;
  width: 100%;
}

.custom-input {
  width: 100%;
  height: 2.875rem !important;
  padding: 0 var(--space-md) !important;
  border: 1px solid var(--color-input-border);
  border-radius: var(--space-sm);
  font-family: var(--font-family-regular);
  font-size: var(--font-size-sm); /* 14px */
  font-weight: 400;
  color: #1f2937;
  background-color: var(--color-white) !important;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  outline: none;
}

.custom-input::placeholder {
  font-family: var(--font-family-regular);
  font-weight:500;
  font-size: var(--font-size-sm);
  line-height: 120%;
  letter-spacing: 0%;
  color: var(--color-input-border);
}

.custom-input:focus {
  border-color: #1e40af;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  background-color: var(--color-white) !important;
}

/* Handle browser autofill */
.custom-input:-webkit-autofill,
.custom-input:-webkit-autofill:hover,
.custom-input:-webkit-autofill:focus,
.custom-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;
  -webkit-text-fill-color: #1f2937 !important;
  background-color: var(--color-white) !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

.custom-input:disabled {
  background-color: var(--color-gray-50);
  color: #9ca3af;
  cursor: not-allowed;
}

.custom-input.error {
  border-color: #dc2626;
}

.custom-input.error:focus {
  border-color: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.password-toggle {
  position: absolute;
  right: var(--space-md);
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: var(--space-xs);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--space-xs);
  transition: background-color 0.2s ease;
  z-index: 10;
}

.password-toggle:hover {
  background-color: #f3f4f6;
}

.password-toggle:focus {
  outline: 2px solid #1e40af;
  outline-offset: 2px;
}

.custom-input-error {
  font-family: var(--font-family-regular);
  font-size: var(--font-size-xs);
  font-weight: 500;
  color: #dc2626;
  margin-top: var(--space-xs);
  line-height: 1.2;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .custom-input {
    height: 2.75rem; /* Slightly smaller on mobile */
    padding: 0 var(--space-sm);
  }
  
  .password-toggle {
    right: var(--space-sm);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/CustomInput.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,8BAA8B;EAC9B,uCAAuC;EACvC,8BAA8B,EAAE,SAAS;EACzC,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,wDAAwD;EACxD,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA,4BAA4B;AAC5B;;;;EAIE,uDAAuD;EACvD,2CAA2C;EAC3C,+CAA+C;EAC/C,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe,EAAE,+BAA+B;IAChD,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".custom-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  width: 100%;\n}\n\n.custom-input-label {\n  font-family: var(--font-family-regular);\n  font-size: var(--font-size-base);\n  font-weight: 400;\n  color: #374151;\n  line-height: 1.2;\n}\n\n.required-asterisk {\n  color: #dc2626;\n  margin-left: 2px;\n}\n\n.custom-input-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-input {\n  width: 100%;\n  height: 2.875rem !important;\n  padding: 0 var(--space-md) !important;\n  border: 1px solid var(--color-input-border);\n  border-radius: var(--space-sm);\n  font-family: var(--font-family-regular);\n  font-size: var(--font-size-sm); /* 14px */\n  font-weight: 400;\n  color: #1f2937;\n  background-color: var(--color-white) !important;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  outline: none;\n}\n\n.custom-input::placeholder {\n  font-family: var(--font-family-regular);\n  font-weight:500;\n  font-size: var(--font-size-sm);\n  line-height: 120%;\n  letter-spacing: 0%;\n  color: var(--color-input-border);\n}\n\n.custom-input:focus {\n  border-color: #1e40af;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  background-color: var(--color-white) !important;\n}\n\n/* Handle browser autofill */\n.custom-input:-webkit-autofill,\n.custom-input:-webkit-autofill:hover,\n.custom-input:-webkit-autofill:focus,\n.custom-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px #ffffff inset !important;\n  -webkit-text-fill-color: #1f2937 !important;\n  background-color: var(--color-white) !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n.custom-input:disabled {\n  background-color: var(--color-gray-50);\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n.custom-input.error {\n  border-color: #dc2626;\n}\n\n.custom-input.error:focus {\n  border-color: #dc2626;\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.password-toggle {\n  position: absolute;\n  right: var(--space-md);\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: var(--space-xs);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--space-xs);\n  transition: background-color 0.2s ease;\n  z-index: 10;\n}\n\n.password-toggle:hover {\n  background-color: #f3f4f6;\n}\n\n.password-toggle:focus {\n  outline: 2px solid #1e40af;\n  outline-offset: 2px;\n}\n\n.custom-input-error {\n  font-family: var(--font-family-regular);\n  font-size: var(--font-size-xs);\n  font-weight: 500;\n  color: #dc2626;\n  margin-top: var(--space-xs);\n  line-height: 1.2;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .custom-input {\n    height: 2.75rem; /* Slightly smaller on mobile */\n    padding: 0 var(--space-sm);\n  }\n  \n  .password-toggle {\n    right: var(--space-sm);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
